import {useSidebar} from '@/context/SidebarContext.jsx'
import {useUser} from '@/hooks/useUser'
import {useUpcomingTrips} from '@/hooks/useTrips'
import {locationCityShort, getStatusLabel} from '@/utils/functions'

export default function WelcomeHome() {
    const {isMobile} = useSidebar()
    const {data: user, isLoading: userLoading} = useUser()
    const {data: tripsData} = useUpcomingTrips({page: 1, perPage: 5})

    const trip = tripsData?.trips?.find(t => t.status !== 'Requested')
    const firstName = user?.first_name || 'there'
    const driverAssigned = !!trip?.driver?.driver_id
    const destinationShort = trip ? locationCityShort(trip.destination) : ''
    const statusText = driverAssigned ? 'confirmed' : (getStatusLabel(trip?.status_label, trip?.status) || '').toLowerCase()
    const confirmationLine = trip && destinationShort && statusText
        ? `Your next ride to ${destinationShort} ${statusText}`
        : ''

    if (isMobile) {
        return (
            <div className="bg-[#efefef] rounded-3xl p-4 text-base">
                <h2 className="max-md:text-xl!">{userLoading ? 'Welcome Back!' : `Welcome Back, ${firstName}!`}</h2>
            </div>
        )
    }

    return (
        <div className="bg-[#efefef] rounded-3xl p-5 text-base">
            <h2 className="max-md:text-xl!">{userLoading ? 'Welcome Back!' : `Welcome Back, ${firstName}!`}</h2>
            {confirmationLine && <p className="mb-0!">{confirmationLine}</p>}
        </div>
    )
}
